// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"76":"common","823":"investor","933":"auth","938":"entrepreneur"}[chunkId] + "-legacy." + {"76":"284516c7","823":"d8ca28c6","933":"1a632f3c","938":"0cb9a073"}[chunkId] + ".js";
};